export default __webpack_public_path__ + "static/media/imgEye.f1e7296d.svg";